import { create } from "zustand";
import { Exam } from "../api-objects/Exam";

interface FilesState {
    userFiles: Exam[] | null;
}

interface FilesStore {
    filesData: FilesState;
    updateFilesData: (updates: Partial<FilesState>) => void;
    clearFiles: () => void;
}

export const useFilesStore = create<FilesStore>((set) => ({
    // Initialize from localStorage
    filesData: JSON.parse(localStorage.getItem("filesData") || "{}") as FilesState || {
        userFiles: null,
    },

    updateFilesData: (updates) => {
        set((state) => {
            const updatedFilesData = { ...state.filesData, ...updates };
            localStorage.setItem("filesData", JSON.stringify(updatedFilesData));
            return { filesData: updatedFilesData };
        });
    },

    clearFiles: () => {
        const clearedFilesData: FilesState = {
            userFiles: null,
        };
        set({ filesData: clearedFilesData });
        localStorage.removeItem("filesData");
    },
}));